import React from 'react';

const ApprovalsIndex = React.lazy(() => import("./index"))


export default [
	{ path: '/approvals', component: ApprovalsIndex, name: 'Approvals' },
]

// import ApprovalsRoutes from "modules/approvals/web/routes"
// routes = _.concat(routes,ApprovalsRoutes)
